/**
 * TIP PRESETS — one list, three screens (2026-11-04).
 *
 * The owner's rule:
 *
 *   > "I mean the 0% no tip card should be removed. Don't want people to leave a $0 tip, the 12%, 15%, 18%,
 *   > 20% and the custom remains."
 *
 * So 0 % is no longer offered as a tap target anywhere a customer or a front desk chooses a tip: the customer
 * booking page, the freelancer booking page, and the walk-in payment modal on the staff dashboard. There is
 * still a way to leave nothing — the tip is a choice, never a charge we invent — but it has to be typed into
 * Custom, not fallen into by tapping the first card.
 *
 * `DEFAULT_TIP_PERCENTAGE` therefore has to be a real preset. The walk-in modal used to start at 0, which is
 * exactly the silent $0 tip this change removes; it now starts where the two customer pages already did.
 */

export const TIP_PRESET_PERCENTAGES = [12, 15, 18, 20];

export const DEFAULT_TIP_PERCENTAGE = 15;

/**
 * Keep a stored/drafted percentage usable. Anything off the preset list - including a 0 saved by an older
 * draft, or a value a URL handed us - becomes the default, so no screen can render with every card unselected
 * while the maths below it charges nothing.
 */
export function normalizeTipPercentage(value, presets = TIP_PRESET_PERCENTAGES) {
  const percent = Number(value);
  return presets.includes(percent) ? percent : DEFAULT_TIP_PERCENTAGE;
}
